import type { FaireProductEntity } from "../../entity_types/product";

export const p_8hd8kfy8xx: FaireProductEntity = {
  token: "p_8hd8kfy8xx",
  type: "product",
  name: "Ceramic Clam Shell Trinket Dish - Assorted",
  brandName: "Earths Elements Wholesale",
  imageUrl:
    "https://cdn.faire.com/fastly/d115fa75f8a6e85a421191fe05528d9267fcea95622d1c3599ba8fa445b0c05e.jpeg",
  priceDollars: 4.5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/614f20762bbd6e444ded0057f3b79235d616d4071e2d0678dc1057a9a0dd54c2.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
